// This file should export everything that is supposed to be used from the other verticals
import { AnonymousCartMetaStore, CustomerCartMetaStore } from "./stores/CartMetaStore";
export { AnonymousCartMetaStore, CustomerCartMetaStore };
import GdprStorage from "./storage/GdprStorage";
export { GdprStorage };
import type { Notification, NotificationHandle } from "./notifications";
export type { Notification, NotificationHandle };
import { notify, NotificationStore } from "./notifications";
export { notify, NotificationStore };
export * as Features from "./Features";
import * as FeatureSessionStoreModule from "./stores/FeatureSessionStore";
export { FeatureSessionStoreModule };
//just temporary for BOC-62659 for backwards compatibility, as consumers expect the FeatureSessionStore field in uidispatcher-api to be filled:
const FeatureSessionStore = FeatureSessionStoreModule.default;
export { FeatureSessionStore };
import BettyHistoryModule from "./betty-history";
export { BettyHistoryModule };
import CountryUtil from "./utils/CountryUtil";
export { CountryUtil };
import * as GlobalModules from "./GlobalModules";
export { GlobalModules };
import LocaleUtil from "./utils/LocaleUtil";
export { LocaleUtil };
import SessionStoreModule from "./stores/SessionStore";
export { SessionStoreModule };
import { SimpleSocket } from "./simplesocket/SimpleSocket";
export { SimpleSocket };
import Tracking from "./tracking/Tracking";
export { Tracking };
import TrackingStore from "./stores/TrackingStore";
export { TrackingStore };
// according to pre-webpack-module-federation-migration code comments,
// the following should only be used in the uidispatcher app code itself
// so, we put them into a separate field
import GtmEventsConsumer from "./tracking/GtmEventsConsumer";
import LoginStore from "./stores/LoginStore";
import { Store } from "./utils/Store";
import * as TagPrisonUtilModule from "./utils/TagPrisonUtil";
const uidispatcherInternal = {
	GtmEventsConsumer,
	LoginStore,
	Store,
	TagPrisonUtilModule,
};
export { uidispatcherInternal };
